import axios from "../axios";
import * as endPoints from "../endpoints";

export const MailSendApi = async (data) =>
  Promise.resolve(axios.post(endPoints.contactForm, data));
